import { render, staticRenderFns } from "./NoticeSetting.vue?vue&type=template&id=26afd4f0&scoped=true&"
import script from "./NoticeSetting.vue?vue&type=script&lang=ts&"
export * from "./NoticeSetting.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeSetting.vue?vue&type=style&index=0&id=26afd4f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26afd4f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VIcon,VRow,VSpacer})
